exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-090efeb6] .el-icon-circle-close{color:#fff}", ""]);

// exports
